import { GoogleSignInButton } from './GoogleSignInButton';
// import { AppleSignInButton } from './AppleSignInButton';

interface SocialLoginButtonsProps {
  onLoginSuccess?: (data: { isNewAccount: boolean }) => void;
}

export function SocialLoginButtons({ onLoginSuccess }: SocialLoginButtonsProps) {
  return (
    <div className="space-y-3">
      <GoogleSignInButton onLoginSuccess={onLoginSuccess} />
      {/* <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-card px-2 text-muted-foreground">or</span>
        </div>
      </div>
      <AppleSignInButton onLoginSuccess={onLoginSuccess} /> */}
    </div>
  );
}
